module.exports = __webpack_public_path__ + "static/img/main-navigation-icon01.d52af762.svg";